module.exports = {
      id: "icon-error-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-error",
      toString: function () {
        return this.url;
      }
    }